import { KatButton } from '@amzn/katal-react';

import { LocaleSelector } from './LocaleSelector';
import { PlacementSelector } from './PlacementSelector';
import { useDevicePreviewNavigation } from '../preview/devicePreview/DevicePreviewNavigationContext';
import styles from './SelectSection.module.css';

const SelectSection = () => {
  const { openTestCampaignModal, isDevicePreviewAvailable } = useDevicePreviewNavigation();

  return (
    <section className={styles.container}>
      <div className={styles.selectors}>
        <PlacementSelector />
        <LocaleSelector />
        {isDevicePreviewAvailable && (
          <div className={styles.testCampaign}>
            <KatButton variant="primary" label="Test Campaign" onClick={openTestCampaignModal} />
          </div>
        )}
      </div>
    </section>
  );
};

export { SelectSection };
